export default {
  title: "Acquaint CRM"
};
